module.exports = __webpack_public_path__ + "img/cutService.5c7933b9.jpg";